// extracted by mini-css-extract-plugin
module.exports = {"gallery":"_1bc12931 center mw8 from flex flex-row flex-wrap justify-center"};